import { render, staticRenderFns } from "./AdminSurveyTemplateManage.vue?vue&type=template&id=6d3b901e&scoped=true"
import script from "./AdminSurveyTemplateManage.vue?vue&type=script&lang=js"
export * from "./AdminSurveyTemplateManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3b901e",
  null
  
)

export default component.exports